/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : previewModelTemplate.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import React, { useRef } from "react";
import { Box } from "@mui/material";
import { ComponentRegistry } from "./registry";
import { PAGE_SIZES } from "./pageSize";

export default function PreviewModalTemplate({ isOpen, onClose, pages }) {
  const template = { pages: pages };
  console.log(pages, "pages");
  const pageRefs = useRef([]);

  /* ---------- RENDER ---------- */
  return (
    <Box>
      {template?.pages?.map((page, pageIndex) => {
        let pxW = PAGE_SIZES[page?.settings?.pageSize]?.width || 794;
        let pxH = PAGE_SIZES[page?.settings?.pageSize]?.height || 1123;

        if (page?.settings?.orientation === "Landscape") {
          [pxW, pxH] = [pxH, pxW];
        }

        return (
          <Box
            key={pageIndex}
            ref={(el) => (pageRefs.current[pageIndex] = el)}
            sx={{
              position: "relative",
              width: pxW,
              height: pxH,
              margin: "20px auto",
              background: page?.settings?.backgroundColor || "#fff",
              border: "1px solid #ddd",
              boxShadow: "0 4px 4px rgba(0,0,0,0.15)",
            }}
          >
            {page?.elements?.map((el) => {
              const reg = ComponentRegistry[el.type];
              if (!reg?.preview) return null;

              return (
                <div
                  key={el.id}
                  style={{
                    position: "absolute",
                    top: el.y,
                    left: el.x,
                    width: el.width,
                    height: el.height,
                    pointerEvents: "none", // 🔒 block editing
                  }}
                >
                  {reg.preview(el)}
                </div>
              );
            })}
          </Box>
        );
      })}
    </Box>
  );
}
